"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.rinkebyTokens = {
    canonicalWrappedEther: { name: 'Rinkeby Canonical Wrapped Ether', symbol: 'WETH', decimals: 18, address: '0xc778417e063141139fce010982780140aa0cd5ab' },
    otherTokens: [{ name: 'Rinkeby Test Token', symbol: 'TST', decimals: 18, address: '0xb7dDCF6B64C05D76Adc497AE78AD83ba3883A294' }]
};
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/wyvern-schemas/dist/tokens/rinkeby/index.js